/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/accountmanage',
    name: '계정 관리',
    view: 'AccountManage'
  },
  {
    path: '/valetreservation',
    name: '발렛 예약',
    view: 'ValetReservation/ValetReservation'
  },
  {
    path: '/parkinglotmanage',
    name: '주차장 관리',
    view: 'ParkingLotManage/ParkingLotManage'
  },
  {
    path: '/periodiccarmanage/:parkinglotidx',
    name: '정기차량 관리',
    view: 'PeriodicCarManage/PeriodicCarManage'
  },
  {
    path: '/periodiccar_allparkinglot',
    name: '정기차량 관리 - 전체 주차장 현황',
    view: 'PeriodicCarManage/PeriodicCar_AllParkingLot'
  },
  {
    path: '/periodiccarstandbymanage',
    name: '정기차량 관리 - 등록 대기 차량 (Waiting.)',
    view: 'PeriodicCarManage/PeriodicCarStandByManage',
  },
  {
    path: '/periodiccar_taskhistory/:periodiccaridx',
    name: '차량정보',
    view: 'PeriodicCarManage/PeriodicCar_TaskHistory',
    props: true,
  },
  {
    path: '/sign',
    view: 'Sign'
  },
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard',
  },


  /////////////////////////////////////////////
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile',
    authRequired: true,
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'
  },
  {
    path: '/typography',
    view: 'Typography'
  },
  {
    path: '/icons',
    view: 'Icons'
  },
  {
    path: '/test',
    view: 'Test'
  },
  {
    path: '/maps',
    view: 'Maps'
  },
  {
    path: '/notifications',
    view: 'Notifications'
  },
  {
    path: '/upgrade',
    name: 'Upgrade to PRO',
    view: 'Upgrade'
  }
]
